import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=d5504e44&scoped=true"
import script from "./NavigationItem.vue?vue&type=script&lang=js"
export * from "./NavigationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5504e44",
  null
  
)

export default component.exports